import React, { useState, useEffect, useMemo } from 'react';
import dayjs from 'dayjs';
import InvoiceSplitDialog from '../../../components/chancemng/obtainorder/InvoiceSplitDialog';
import {
  Box, Typography, CircularProgress, Chip,
  Table, TableHead, TableBody, TableFooter, TableRow, TableCell,
} from '@mui/material';
import _ from 'lodash';

import { useSnackbar } from 'notistack';
import { useSelector,useDispatch } from 'react-redux';

import * as taxBillApi from '../../../lib/api/taxbill';
import { useChanceStore } from '../../../store/chanceStore'

const OrderCompanyBillListContainer = ({
  chance, 
  type,
  roUuid,
  mode,
  selectedRow,
  costs: propCosts,
  handleCancle, 
}) => {
//  alert(roUuid);
  const dispatch = useDispatch();

  const [rows, setRows] = useState([]);
  const [loading, setLoading    ] = useState(true);
  const { enqueueSnackbar } = useSnackbar();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogProps, setDialogProps] = useState({});
  const [selectedPartnerUuid, setSelectedPartnerUuid] = useState('');
  const [savedRows, setSavedRows] = useState([]);

  // 상태 조회(selector)
  const billInfList = useChanceStore(state => state.billInfList)
  const billInvList = useChanceStore(state => state.billInvList)

  // 액션 가져오기
  const setBillInfList = useChanceStore(state => state.setBillInfList)
  const setBillInvList = useChanceStore(state => state.setBillInvList)

useEffect(() => setBillInfList(rows), [rows, setBillInfList]);
useEffect(() => setBillInvList(savedRows), [savedRows, setBillInvList]);

    
  useEffect(() => {

    if (chance?.prjUuid) {
      if(mode == 'add' ) {
        loadBillInfCrt(chance?.prjUuid);
      } else {
        loadBillInfList(chance?.prjUuid, roUuid);
        loadBillInvList(chance?.prjUuid, roUuid);
      }
    }
  }, [chance?.prjUuid, roUuid])

  const getSelectedPartnerUuid = () => {
    return selectedPartnerUuid;
  };

  const loadBillInfCrt = async (id) => {
    try {
        const response = await taxBillApi.getInvoiceCrt(id);
        if (response.data.list) {
          const list = response.data.list;
          // installment 기본값 1 세팅
          const listWithInstallment = list.map(r => {
            const billAmt = Number(r.billAmt) || 0;
            const billVat = Math.round(billAmt * 0.1);
            return {
              ...r,
              installment: r.installment || 1,
              billVat: r.billVat ? Number(r.billVat) : billVat,
              billTot: r.billTot ? Number(r.billTot) : billAmt + billVat,
            };
          });
          setRows(listWithInstallment);

          // 각 행마다 기본 세금계산서 1개 자동 생성 (계약완료일 기준)
          const defaultPlanDt = chance?.expDay ? dayjs(chance.expDay).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD');
          const defaultInvList = listWithInstallment.map(r => ({
            id: r.billUuid,
            invUuid: r.billUuid,
            billUuid: r.billUuid,
            partnerUuid: r.partnerUuid,
            billTyp: r.billTyp,
            partnerNm: r.partnerNm,
            invAmt: Number(r.billAmt),
            invVat: Math.round(Number(r.billAmt) * 0.1),
            invTot: Number(r.billAmt) + Math.round(Number(r.billAmt) * 0.1),
            invTxt: r.partnerNm,
            reqPlanDt: defaultPlanDt,
            reqCompDt: defaultPlanDt,
            procPlanDt: defaultPlanDt,
            rsltCompDt: defaultPlanDt,
            reqCompYn: 'N',
            evidenceType: 'TAX_INVOICE',
            currencyType: null,
            foreignAmount: null,
          }));
          setSavedRows(defaultInvList);

          if (mode != 'view') {
            setBillInfList(listWithInstallment);
            setBillInvList(defaultInvList);
          }
          setLoading(false);
        }
    } catch (err) {
        let message =
            typeof err.response !== 'undefined'
                ? err.response.data.message
                : err.message;
        enqueueSnackbar(message, {
            variant: 'error',
        });
    }
  }
  
  const normalizeList = (list) =>
    list.map(r => ({
      ...r,
      billAmt: Number(r.billAmt),
      billVat: Number(r.billVat),
      billTot: Number(r.billTot),
      issueReq: Number(r.issueReq),
      issueComp: Number(r.issueComp),
      collComp: Number(r.collComp),
    }));

  const loadBillInfList = async (prjUuid, roUuid) => {
    try {

        if(typeof roUuid == "undefined" || roUuid == null || roUuid == "")
          return true;

        const response = await taxBillApi.getInvoiceInfList(prjUuid,roUuid );
        if (response.data.list) {
          const normalized = normalizeList(response.data.list);
          setRows(normalized);
          dispatch({
            type: 'projectModule/orderAdd/SET_BILL_INF_LIST',
            payload: normalized
          });          
          
          setBillInfList(normalized);
          setLoading(false);
          
        }
    } catch (err) {
        let message =
            typeof err.response !== 'undefined'
                ? err.response.data.message
                : err.message;
        enqueueSnackbar(message, {
            variant: 'error',
        });
    }
  }

  
  
  const loadBillInvList = async (prjUuid, roUuid) => {
    try {

        if(typeof roUuid == "undefined" || roUuid == null || roUuid == "")
          return true;

        const response = await taxBillApi.getInvoiceInvDataList(prjUuid,roUuid );
        if (response.data.list) {

          setSavedRows(response.data.list);
          dispatch({
            type: 'projectModule/orderAdd/SET_BILL_INV_LIST',
            payload: rows
          });          
          
          if( mode != 'view') setBillInvList(response.data.list);
          setLoading(false);
          
        }
    } catch (err) {
        let message =
            typeof err.response !== 'undefined'
                ? err.response.data.message
                : err.message;
        enqueueSnackbar(message, {
            variant: 'error',
        });
    }
  }

  const handleInstallmentClick = (row) => {
    setSelectedPartnerUuid(row.partnerUuid);
    setDialogProps({
      type: row.billTyp,
      billUuid: row.billUuid,
      installmentCount: row.installment,
      totalAmount: row.billAmt,
      billVat: Math.floor(row.billAmt * 0.1),
      defaultPlanDt: chance?.expDay ? dayjs(chance.expDay).format('YYYY-MM-DD') : null, // 계약완료일 전달      
      onSave: (updatedSplits) => {
        // ---- savedRows 업데이트 (functional update) ----
        setSavedRows(prevSaved => {
          const remaining = prevSaved.filter(
            item => item.partnerUuid !== row.partnerUuid
          );
          const newSplits = updatedSplits.map(split => ({
            ...split,
            partnerUuid: row.partnerUuid,
            issueReq: split.amt,
          }));
          const newSaved = [...remaining, ...newSplits];
          // 즉시 store 에도 반영
          // setBillInvList(newSaved);
          return newSaved;
        });
  
        // ---- rows 업데이트 (functional update) ----
        setRows(prevRows => {
          const newRows = prevRows.map(r =>
            r.partnerUuid === row.partnerUuid
              ? {
                  ...r,
                  installment: updatedSplits.length,

                  //billAmt: updatedSplits.reduce((sum, s) => sum + Number(s.invAmt), 0),
                  billVat: updatedSplits.reduce((sum, s) => sum + Number(s.invVat), 0),
                  billTot: updatedSplits.reduce((sum, s) => sum + Number(s.invTot), 0),

                  issueReq: updatedSplits
                    .filter(s => s.reqCompYn === 'N')
                    .reduce((sum, s) => sum + Number(s.invAmt), 0),
                  issueComp: updatedSplits
                    .filter(s => s.reqCompYn === 'Y')
                    .reduce((sum, s) => sum + Number(s.invAmt), 0),
                  collComp: updatedSplits
                    .filter(s => s.procCompYn === 'Y')
                    .reduce((sum, s) => sum + Number(s.invAmt), 0),
                }
              : r
          );
          // 즉시 store 에도 반영
          // setBillInfList(newRows);
          return newRows;
        });
           
        setDialogOpen(false);
      },
    });
    setDialogOpen(true);
  };

  const columns = useMemo(
    () => [
    { field: 'billTyp', headerName: '종류',
      type: 'string',
      width: 100 },
    {
      field: 'partnerUuid',
      headerName: 'partnerUuid',
      hide: true,
      type: 'string',
      editable: false,
      disableExport: true,
    },
    { field: 'partnerNm', headerName: '매출(매입)처', minWidth:200},
    {
      field: 'billAmt',
      headerName: '세금계산서금액',
      type: 'number',
      width: 150,
      valueFormatter: (params) => {
        const valueFormatted = Number(params).toLocaleString('ko-KR');
        return `₩ ${valueFormatted}`;
      },
    },
    {
      field: 'billVat',
      headerName: '부가세',
      type: 'number',
      width: 150,
      valueFormatter: (params) => {
        const valueFormatted = Number(params).toLocaleString('ko-KR');
        return `₩ ${valueFormatted}`;
      },
    },
    {
      field: 'billTot',
      headerName: '합계금액',
      type: 'number',
      width: 150,
      valueFormatter: (params) => {
        const valueFormatted = Number(params).toLocaleString('ko-KR');
        return `₩ ${valueFormatted}`;
      },
    },
    {
      field: 'installment',
      headerName: '분할',
      width: 100,
      align: 'center',
      headerAlign: 'center',      
      renderCell: (params) => (
        <Typography
        variant="body2"
        color="primary"
        sx={{ 
          cursor: 'pointer',
          textDecoration: 'underline',
          width: '100%',
          textAlign: 'center',
        }}
        onClick={() => handleInstallmentClick(params.row)}
      >
        {params.value}
      </Typography>
      ),
    },
  //   {
  //     field: 'issueReq',
  //     headerName: '발행요청금액',
  //     type: 'number',
  //     width: 200,
  //     valueFormatter: (params) => {
  //         const valueFormatted = Number(params).toLocaleString('ko-KR');
  //         return `₩ ${valueFormatted}`;
  //     },
  //   },
  //   {
  //     field: 'issueComp',
  //     headerName: '발행완료금액',
  //     type: 'number',
  //     width: 200,
  //     valueFormatter: (params) => {
  //       const valueFormatted = Number(params).toLocaleString('ko-KR');
  //       return `₩ ${valueFormatted}`;
  //   },
  // },
  //   {
  //     field: 'collComp',
  //     headerName: '수금(지급)금액',
  //     type: 'number',
  //     width: 200,
  //     valueFormatter: (params) => {
  //       const valueFormatted = Number(params).toLocaleString('ko-KR');
  //       return `₩ ${valueFormatted}`;
  //   },
  // },
  // {
  //   field: 'crtDt',
  //   headerName: '등록일자',
  //   maxWidth: 180,
  //   flex: 1,
  //   type: 'string',
  //   editable: false,
  //   align: 'center',
  //   headerAlign: 'center',
  // },
  ],
    [],
  );
  const columnVisibilityModel={
    // Hide columns status and traderName, the other columns will remain visible
    partnerUuid: false,    
  };

  // 합계 계산
  const totalBillAmt = rows.reduce((s, r) => s + Number(r.billAmt || 0), 0);
  const totalBillVat = rows.reduce((s, r) => s + Number(r.billVat || 0), 0);
  const totalBillTot = rows.reduce((s, r) => s + Number(r.billTot || 0), 0);

  const fmt = (v) => `₩\u00a0${Number(v).toLocaleString('ko-KR')}`;

  const typeBadge = (typ) => ({
    color: typ === '매출' ? 'primary' : 'warning',
    label: typ,
  });

  return (
    <Box sx={{ width: '100%', p: 2 }}>
      <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1.5 }}>
        매입·매출 거래 내역
      </Typography>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Table size="small" sx={{ border: '1px solid #e0e0e0', borderRadius: 1, overflow: 'hidden' }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              {['종류', '매출(매입)인', '세금계산서금액', '부가세', '합계금액', '분할'].map((h) => (
                <TableCell
                  key={h}
                  align={h === '종류' || h === '매출(매입)인' ? 'left' : 'right'}
                  sx={{ fontWeight: 700, color: 'text.secondary', fontSize: '0.78rem', py: 1.2 }}
                >
                  {h}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 4, color: 'text.disabled' }}>
                  등록된 거래 내역이 없습니다.
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, idx) => {
                const badge = typeBadge(row.billTyp);
                return (
                  <TableRow
                    key={row.billUuid || idx}
                    sx={{
                      '&:last-child td': { borderBottom: 0 },
                      '&:hover': { backgroundColor: '#fafafa' },
                    }}
                  >
                    <TableCell>
                      <Chip
                        label={badge.label}
                        color={badge.color}
                        size="small"
                        variant="outlined"
                        sx={{ fontWeight: 600, fontSize: '0.72rem' }}
                      />
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" fontWeight={500}>{row.partnerNm}</Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography variant="body2">{fmt(row.billAmt)}</Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography variant="body2" color="text.secondary">{fmt(row.billVat)}</Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography variant="body2" fontWeight={600}>{fmt(row.billTot)}</Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography
                        variant="body2"
                        color="primary"
                        sx={{ cursor: 'pointer', textDecoration: 'underline', fontWeight: 600 }}
                        onClick={() => handleInstallmentClick(row)}
                      >
                        {row.installment ?? 0}
                      </Typography>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
          {/* 합계 행 */}
          {rows.length > 0 && (
            <TableFooter>
              <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                <TableCell colSpan={2} sx={{ fontWeight: 700, color: 'text.primary' }}>합계</TableCell>
                <TableCell align="right" sx={{ fontWeight: 700 }}>{fmt(totalBillAmt)}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 700, color: 'text.secondary' }}>{fmt(totalBillVat)}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 700, color: 'primary.main' }}>{fmt(totalBillTot)}</TableCell>
                <TableCell />
              </TableRow>
            </TableFooter>
          )}
        </Table>
      )}

      <InvoiceSplitDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        partnerUuid={selectedPartnerUuid}
        partnerName={chance?.cstNm}
        prjUuid={chance?.prjUuid}
        roUuid={roUuid?roUuid:null}
        billrows={savedRows.filter((item) => item.partnerUuid === getSelectedPartnerUuid())}
        mode={mode}  
        {...dialogProps} 
        totalVat={dialogProps.totalVat} 
      />
    </Box>
  );
};

export default OrderCompanyBillListContainer;
